var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"header-wrapper"},[_c('img',{attrs:{"alt":"Cover picture","src":_vm.cover}}),_c('div',{staticClass:"overlay-mask"})]),_c('h1',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }